/* SpawnAnything — face system mode (comparison switch, see labs/models.html ?faces=…):
   'fein' = painted faces on a finer head layer (default), 'grob' = painted faces at body resolution,
   'aus' = no painted faces/hair/hats, only the recipe's own add boxes. */
let FACE_MODE = 'fein';
export const FACE_MODES = ['fein', 'grob', 'aus'];
export function setFaceMode(m) { if (FACE_MODES.includes(m)) FACE_MODE = m; return FACE_MODE; }
export const faceMode = () => FACE_MODE;
// AI figures (text, photo, library) render without the face painter - owner's pick 2026-10-01 (labs/models.html, v04 + 'aus').
// Hand-made figures keep the global mode: their helmets, crowns and hair come from the hair/hat library.
export const AI_FACE_MODE = 'aus';
/** Mode for one recipe: a recipe may carry its own faceMode (set when an AI figure is adopted). */
export const faceModeOf = rec => (rec && FACE_MODES.includes(rec.faceMode) ? rec.faceMode : FACE_MODE);
